import * as React from 'react'

import { getConfigBySite } from '../../../../config/sites'
import { config } from '../../../../common/config'
import useDidMount from '../../../../common/hooks/useDidMount'
import { Props } from '../../../containers/homePageContainer/createHomePageContainer'
import createAutoSuggestDataContainer from '../../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../../components/autosuggest/autoSuggestLogicContainer'
import AutoSuggest from '../../../v0/components/autosuggest/autosuggest'
import CategoryTilesBlock from '../../../components/homePage/categoryTilesBlock'
import ElementsItemsBlock from '../../../components/homePage/elementsItemsBlock'
import ItemsShowcaseBlock from '../../../components/homePage/itemsShowcaseBlock'
import FeaturedAuthorBlock from '../../../components/homePage/featuredAuthorBlock'
import FreeItemsBlock from '../../../components/homePage/freeItemsBlock'
import SearchHeaderBlock from '../../../components/homePage/searchHeaderBlock'
import NewestItemsBlock from '../../../components/homePage/newestItemsBlock/newestItemsBlock'
import ValuePropositionBlock from '../../../components/homePage/valuePropositionBlock/valuePropositionBlock'
import FullWidthBannerBlock from '../../../components/categoryPage/fullWidthBannerBlock'
import QualityItemsBlock from '../../../components/homePage/qualityItemsBlock/qualityItemsBlock'
import SVGSpriteWrapper from '../../../components/svgSpriteWrapper'
import TextCategoriesBlock from '../../../components/homePage/textCategoriesBlock'

import {
  selectBlocksFromActiveFeatureFlip,
  shouldShowBlock,
  isNotEmpty
} from '../../../../common/utils/pageBlocks'

import {
  IBlockComponentsMap,
  IRenderHomePageBlocks
} from '../../../../typings/pageBlocks'

import * as autoSuggestStyles from '../../../v0/components/autosuggest/themes/homepage.newdesign.module.css'
import * as styles from '../homePage.module.css'
import { hasFeature } from '../../../../common/utils/features'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

const homeLookupMap: IBlockComponentsMap = {
  CategoryTilesBlock,
  TextCategoriesBlock,
  QualityItemsBlock,
  ItemsShowcaseBlock,
  ValuePropositionBlock,
  NewestItemsBlock,
  FeaturedAuthorBlock,
  ElementsItemsBlock,
  FreeItemsBlock,
  FullWidthBannerBlock
}

const renderBlocks = ({
  blocks,
  currentSite,
  location,
  reportItemClick,
  lookupMap = homeLookupMap,
  permitScheduledBlocks
}: IRenderHomePageBlocks) =>
  blocks
    .filter(block =>
      shouldShowBlock({ block, currentSite, location, permitScheduledBlocks })
    )
    .map((block, index) => {
      const MatchedComponent = lookupMap[block.componentType]

      return MatchedComponent ? (
        <MatchedComponent
          key={block.componentType + index}
          currentSite={currentSite}
          location={location}
          reportItemClick={reportItemClick}
          {...block}
        />
      ) : null
    })
    .filter(isNotEmpty)

const RedesignedBlocksTemplate = ({
  currentSite,
  location,
  categories,
  newestItemsData,
  fetchNewestItemsByCategory,
  reportItemClick,
  makeSearchLink,
  metadata,
  blocks,
  blocksB,
  blocksC,
  blocksD,
  experiments
}: Props) => {
  const selectedBlocks = selectBlocksFromActiveFeatureFlip({
    page: 'home',
    data: { blocks, blocksB, blocksC, blocksD },
    currentSite,
    location,
    experiments
  })

  const enhancedBlocks = selectedBlocks.map(block => {
    if (block.componentType === 'NewestItemsBlock') {
      return {
        ...block,
        categories,
        fetchNewestItemsByCategory,
        itemsCategory: newestItemsData.itemsCategory,
        itemsPendingCategory: newestItemsData.itemsPendingCategory,
        loadingCachedCategory: newestItemsData.loadingCachedCategory
      }
    }

    if (
      block.componentType === 'CategoryTilesBlock' &&
      hasFeature('gridViewCategoryNav', currentSite, location, experiments)
    ) {
      return { ...block, componentType: 'TextCategoriesBlock' }
    }

    return block
  })

  const permitScheduledBlocks = useDidMount()

  return (
    <SVGSpriteWrapper
      spriteURL={`${config.assets.PUBLIC_PATH}/images/home-page/new-design/sprites-${currentSite}-v2.svg`}
    >
      <div
        className={styles.searchHeaderSection}
        data-test-selector="searchBlock"
      >
        <SearchHeaderBlock
          currentSite={currentSite}
          originalHeader={metadata?.search_area.heading}
          originalSubHeading={metadata?.search_area.sub_heading}
          location={location}
          experiments={experiments}
        >
          <AutoSuggestContainer
            inputName="term"
            value=""
            placeholder={getConfigBySite(
              currentSite,
              'home_search_placeholder'
            )}
            currentSite={currentSite}
            locationParams={{}}
            makeSearchLink={makeSearchLink}
            styles={autoSuggestStyles}
            showCategories={true}
          />
        </SearchHeaderBlock>
      </div>

      {renderBlocks({
        blocks: enhancedBlocks,
        currentSite,
        location,
        reportItemClick,
        permitScheduledBlocks
      })}
    </SVGSpriteWrapper>
  )
}

export default RedesignedBlocksTemplate
